export const disabledByRole = (roles = [], allowed = []) => {
  return roles.some((role) => allowed.includes(role.name));
};
